import { generateTestId } from "@client-shared";

export const setOnboardingSuccessTestId = (identifier: string): string =>
  generateTestId("OnboardingSuccess", identifier);
